/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ObjectCategory
 */
export interface ObjectCategory {
  /**
   *
   * @type {number}
   * @memberof ObjectCategory
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof ObjectCategory
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof ObjectCategory
   */
  slug?: string | null
}

/**
 * Check if a given object implements the ObjectCategory interface.
 */
export function instanceOfObjectCategory(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value

  return isInstance
}

export function ObjectCategoryFromJSON(json: any): ObjectCategory {
  return ObjectCategoryFromJSONTyped(json, false)
}

export function ObjectCategoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ObjectCategory {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: !exists(json, 'name') ? undefined : json['name'],
    slug: !exists(json, 'slug') ? undefined : json['slug'],
  }
}

export function ObjectCategoryToJSON(value?: ObjectCategory | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    slug: value.slug,
  }
}
